(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[742],{

/***/ 88997:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(91979);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21229:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/password-form.10c0a6a7.svg","height":121,"width":280});

/***/ }),

/***/ 36879:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/password.8b127325.svg","height":610,"width":702});

/***/ }),

/***/ 56042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_Button; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/utils/environment/index.ts
var environment = __webpack_require__(98404);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    border: 1px solid;\n    border-radius: 16px;\n    cursor: pointer;\n    display: block;\n    font-weight: ",
        ";\n    height: auto;\n    text-align: center;\n    text-decoration: none;\n    transition: background-color ",
        ", opacity ",
        ";\n    width: fit-content;\n    font-family: ",
        ";\n\n    span {\n      vertical-align: middle;\n    }\n\n    &:active {\n      opacity: 0.75;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n    }\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapperModifiers = {
    fullWidth: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("width:100%;");
    },
    withIcon: function() {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("align-items:center;display:inline-flex;justify-content:center;svg{height:20px;width:20px;}svg + span{margin-left:10px;}");
    }
};
var variantModifiers = {
    primary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.brandColor1Darkened, ";border-color:", theme.colors.brandColor1Darkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    secondary: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.red, ";border-color:", theme.colors.red, ";color:", theme.colors.white, ";&:hover{background-color:", theme.colors.redDarkened, ";border-color:", theme.colors.redDarkened, ";}&:disabled{background-color:", theme.colors.gray3, ";border-color:", theme.colors.gray3, ";color:", theme.colors.white, ";}");
    },
    alternate: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.white, ";border-color:", theme.colors.brandColor1, ";color:", theme.colors.brandColor1, ";&:hover{background-color:", theme.colors.brandColor1Light, ";}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray3, ";color:", theme.colors.gray3, ";}");
    },
    alternate2: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("background-color:", theme.colors.brandColor1Light, ";border-color:", theme.colors.brandColor1Light, ";color:", theme.colors.brandColor1, ";&:hover{filter:brightness(0.95);}&:disabled{background-color:", theme.colors.gray1, ";border-color:", theme.colors.gray1, ";color:", theme.colors.gray3, ";filter:brightness(1);}");
    }
};
var sizeModifiers = {
    small: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:8px;font-size:", theme.font.sizes.xsmall, ";");
    },
    medium: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:16px;font-size:", theme.font.sizes.small, ";");
    },
    large: function(theme) {
        return /*#__PURE__*/ (0,emotion_react_browser_esm.css)("padding:21px;font-size:", theme.font.sizes.small, ";");
    }
};
var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("button", {
    target: "ebjwbf90"
})(function(param) {
    var theme = param.theme, fullWidth = param.fullWidth, size = param.size, hasIcon = param.hasIcon, variant = param.variant;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.font.weight.bold, theme.transition.default, theme.transition.default, theme.font.family.averta, !!fullWidth && wrapperModifiers.fullWidth(), hasIcon && wrapperModifiers.withIcon(), sizeModifiers[size](theme), variantModifiers[variant](theme));
});

;// CONCATENATED MODULE: ./src/components/atoms/Button/Button.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var children = _param.children, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _asLink = _param.asLink, asLink = _asLink === void 0 ? false : _asLink, _size = _param.size, size = _size === void 0 ? "medium" : _size, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, icon = _param.icon, props = _objectWithoutProperties(_param, [
        "children",
        "fullWidth",
        "asLink",
        "size",
        "variant",
        "icon"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, _objectSpread({
        className: "ButtonStyles__Wrapper",
        fullWidth: fullWidth,
        size: size,
        variant: variant,
        hasIcon: !!icon,
        ref: ref
    }, asLink ? {
        as: "a"
    } : {}, props, {
        children: [
            icon,
            !!children && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                children: children
            })
        ]
    }));
});
if (environment/* isDevelopment */.y) {
    Button.displayName = "Button";
}
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/atoms/Button/index.ts




/***/ }),

/***/ 4969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FormErrorMessage_FormErrorMessage; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/icons/index.tsx + 99 modules
var icons = __webpack_require__(46912);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/FormErrorMessage.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    align-items: center;\n    background-color: rgba(235, 87, 87, 0.1); // theme.colors.red at 0.1 opacity\n    border: 0.5px solid rgba(235, 87, 87, 0.5); // theme.colors.red at 0.5 opacity\n    border-radius: 6px;\n    color: ",
        ";\n    display: flex;\n    margin-bottom: 20px;\n    padding: 6.5px 10px;\n\n    svg {\n      height: 12px;\n      margin-right: 8px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e742rpk0"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.red);
});
var Message = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e742rpk1"
})("font-size:11px;");

;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/FormErrorMessage.tsx




var FormErrorMessage = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        className: "FormErrorMessageStyles__Wrapper",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icons/* AlertTriangleIcon */.lM, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Message, {
                children: message
            })
        ]
    });
};
/* harmony default export */ var FormErrorMessage_FormErrorMessage = (FormErrorMessage);

;// CONCATENATED MODULE: ./src/components/atoms/FormErrorMessage/index.ts




/***/ }),

/***/ 85787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fS": function() { return /* binding */ AuthFormWrapper; },
/* harmony export */   "Qd": function() { return /* binding */ AuthFormTitle; },
/* harmony export */   "Bt": function() { return /* binding */ AuthForm; },
/* harmony export */   "y6": function() { return /* binding */ AuthFromSection; },
/* harmony export */   "GB": function() { return /* binding */ FooterOptionText; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82227);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 33px;\n    padding: 40px;\n    width: 360px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: 26px;\n    font-weight: ",
        ";\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n\n    a {\n      color: currentColor;\n      font-weight: ",
        ";\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AuthFormWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e108q8z60"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), theme.colors.lightBg);
});
var AuthFormTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("h2", {
    target: "e108q8z61"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), theme.colors.gray8, theme.font.weight.normal);
});
var AuthForm = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("form", {
    target: "e108q8z62"
})("display:grid;grid-gap:40px;gap:40px;");
var AuthFromSection = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e108q8z63"
})("display:grid;gap:20px;grid-gap:20px;");
var FooterOptionText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("p", {
    target: "e108q8z64"
})(function(param) {
    var theme = param.theme;
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject2(), theme.colors.gray7, theme.font.sizes.xsmall, theme.font.weight.normal, theme.font.weight.bold);
});


/***/ }),

/***/ 34328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    cursor: pointer;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n    width: 100%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "et75v90"
})("align-content:center;display:flex;justify-content:space-between;width:100%;");
var Logo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v91"
})("min-width:112px;width:auto;");
var AuthNav = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("nav", {
    target: "et75v92"
})("display:flex;gap:40px;align-items:center;");
var LinkLabel = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("a", {
    target: "et75v93"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.gray4, theme.font.sizes.medium, theme.font.weight.normal);
});

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/AuthHeaderNav.tsx






var AuthHeaderNav = function() {
    var router = (0,next_router.useRouter)();
    var isLandingPage = /^\/$/.test(router.route);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                        src: "/img/logo.svg",
                        alt: "Riiid for Classrooms logo",
                        width: 100,
                        height: 30,
                        placeholder: "blur",
                        blurDataURL: "/img/logo.svg"
                    })
                })
            }),
            isLandingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthNav, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signin",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign In"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_link["default"], {
                        href: "/signup",
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(LinkLabel, {
                            children: "Sign Up"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AuthHeaderNav_AuthHeaderNav = (AuthHeaderNav);

;// CONCATENATED MODULE: ./src/components/molecules/AuthHeaderNav/index.ts


;// CONCATENATED MODULE: ./src/layouts/Auth/styles.ts

var styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e703ikv0"
})("display:grid;grid-template-rows:auto 1fr;gap:40px;grid-gap:40px;padding:60px;width:100%;min-height:100vh;height:100%;");

;// CONCATENATED MODULE: ./src/layouts/Auth/index.tsx




var AuthLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(AuthHeaderNav_AuthHeaderNav, {}),
            children
        ]
    });
};
/* harmony default export */ var Auth = (AuthLayout);


/***/ }),

/***/ 91979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forgot_password_page; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ./src/layouts/Auth/index.tsx + 4 modules
var Auth = __webpack_require__(34328);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/templates/Auth/index.tsx + 1 modules
var templates_Auth = __webpack_require__(55571);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../packages/swagger/lib/esm/index.js + 60 modules
var esm = __webpack_require__(29757);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ./src/components/forms/AuthForm/index.ts
var AuthForm = __webpack_require__(85787);
// EXTERNAL MODULE: ./public/img/illustrations/password-form.svg
var password_form = __webpack_require__(21229);
// EXTERNAL MODULE: ./src/components/atoms/TextField/index.ts + 3 modules
var TextField = __webpack_require__(46903);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(56042);
// EXTERNAL MODULE: ./src/components/atoms/FormErrorMessage/index.ts + 2 modules
var FormErrorMessage = __webpack_require__(4969);
// EXTERNAL MODULE: ./src/components/icons/index.tsx + 99 modules
var icons = __webpack_require__(46912);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/components/molecules/ResetPasswordEmailSentCard/ResetPasswordEmailSentCard.styles.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 33px;\n    width: 360px;\n    padding: 40px;\n    text-align: center;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: 26px;\n    font-weight: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n    cursor: auto;\n\n    span {\n      color: currentColor;\n      font-weight: ",
        ";\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1baij3l0"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject(), theme.colors.lightBg);
});
var InfoTextWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1baij3l1"
})("display:grid;gap:20px;grid-gap:20px;margin-top:40px;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("h2", {
    target: "e1baij3l2"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject1(), theme.colors.gray8, theme.font.weight.normal);
});
var Email = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e1baij3l3"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject2(), theme.colors.gray4, theme.font.sizes.xsmall, theme.font.weight.semiBold);
});
var InfoText = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e1baij3l4"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject3(), theme.colors.gray4, theme.font.sizes.xsmall);
});
var FooterText = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e1baij3l5"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(_templateObject4(), theme.colors.gray7, theme.font.sizes.xsmall, theme.font.weight.normal, theme.font.weight.bold);
});

;// CONCATENATED MODULE: ./src/components/molecules/ResetPasswordEmailSentCard/ResetPasswordEmailSentCard.tsx




var ResetPasswordEmailSentCard = function(param) {
    var email = param.email, resetForm = param.resetForm;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(icons/* MailVerifiedIcon */.hi, {
                width: "92px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(InfoTextWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Title, {
                        children: "Check your mail"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Email, {
                        children: email
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(InfoText, {
                        children: "You will receive a password reset link if an account exists for this email. "
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(FooterText, {
                        children: [
                            "Didn't get an email? ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("span", {
                                onClick: resetForm,
                                children: "Resend email."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ResetPasswordEmailSentCard_ResetPasswordEmailSentCard = (ResetPasswordEmailSentCard);

;// CONCATENATED MODULE: ./src/components/molecules/ResetPasswordEmailSentCard/index.ts



// EXTERNAL MODULE: ./src/hooks/useBoolean/index.ts + 1 modules
var useBoolean = __webpack_require__(80491);
// EXTERNAL MODULE: ./src/utils/validations/index.ts + 1 modules
var validations = __webpack_require__(73954);
;// CONCATENATED MODULE: ./src/components/forms/ForgotPasswordForm/ForgotPasswordForm.styles.tsx
function ForgotPasswordForm_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ForgotPasswordForm_styles_templateObject() {
    var data = ForgotPasswordForm_styles_taggedTemplateLiteral([
        "\n    background-color: ",
        ";\n    border-radius: 33px;\n    max-width: 360px;\n    padding: 40px;\n  "
    ]);
    ForgotPasswordForm_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ForgotPasswordForm_styles_templateObject1() {
    var data = ForgotPasswordForm_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    margin-top: 40px;\n    margin-bottom: 20px;\n    font-size: 26px;\n    font-weight: ",
        ";\n  "
    ]);
    ForgotPasswordForm_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ForgotPasswordForm_styles_templateObject2() {
    var data = ForgotPasswordForm_styles_taggedTemplateLiteral([
        "\n    color: ",
        ";\n    font-size: ",
        ";\n    margin-bottom: 20px;\n  "
    ]);
    ForgotPasswordForm_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ForgotPasswordForm_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1d4w86f0"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(ForgotPasswordForm_styles_templateObject(), theme.colors.lightBg);
});
var ForgotPasswordForm_styles_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("h2", {
    target: "e1d4w86f1"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(ForgotPasswordForm_styles_templateObject1(), theme.colors.gray8, theme.font.weight.normal);
});
var ForgotPasswordForm_styles_InfoText = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e1d4w86f2"
})(function(param) {
    var theme = param.theme;
    return (0,emotion_react_browser_esm.css)(ForgotPasswordForm_styles_templateObject2(), theme.colors.gray4, theme.font.sizes.xsmall);
});
var Form = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("form", {
    target: "e1d4w86f3"
})(".ButtonStyles__Wrapper{margin-top:30px;}")));

;// CONCATENATED MODULE: ./src/components/forms/ForgotPasswordForm/ForgotPasswordForm.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}














var ForgotPasswordForm = function(param) {
    var initialError = param.initialError;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = _slicedToArray((0,useBoolean/* useBoolean */.k)(false), 2), emailSent = ref1[0], setEmailSent = ref1[1];
    var ref2 = (0,react.useState)(initialError), forgotPasswordError = ref2[0], setForgotPasswordError = ref2[1];
    var emailValidation = (0,react.useMemo)(function() {
        return (0,validations/* validateEmail */.oH)(email);
    }, [
        email
    ]);
    var handleEmailChange = function(value) {
        setEmail(value);
    };
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        setForgotPasswordError(undefined);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return (0,esm/* forgotPassword */.gFZ)({
                            email: email
                        });
                    case 5:
                        setEmailSent.setTrue();
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](2);
                        setForgotPasswordError("Something went wrong");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    8
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetForm = function() {
        setEmail("");
        setEmailSent.setFalse();
        setForgotPasswordError(undefined);
    };
    if (emailSent) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ResetPasswordEmailSentCard_ResetPasswordEmailSentCard, {
            email: email,
            resetForm: resetForm
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(ForgotPasswordForm_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                src: password_form/* default */.Z,
                alt: "Left key and right lock"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ForgotPasswordForm_styles_Title, {
                children: "Forgot Password"
            }),
            forgotPasswordError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(FormErrorMessage/* default */.Z, {
                message: forgotPasswordError
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ForgotPasswordForm_styles_InfoText, {
                children: "Please enter your registered email to receive password reset instructions"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(AuthForm/* AuthForm */.Bt, {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(TextField/* default */.Z, {
                        label: "Email",
                        name: "email",
                        type: "email",
                        inputMode: "email",
                        placeholder: "Email address",
                        required: true,
                        value: email,
                        error: emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.error,
                        isValid: emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.isValid,
                        onChange: handleEmailChange
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(Button/* default */.Z, {
                        type: "submit",
                        fullWidth: true,
                        disabled: !(emailValidation === null || emailValidation === void 0 ? void 0 : emailValidation.isValid),
                        children: "Reset Password"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ForgotPasswordForm_ForgotPasswordForm = (ForgotPasswordForm);

;// CONCATENATED MODULE: ./src/components/forms/ForgotPasswordForm/index.ts


// EXTERNAL MODULE: ./public/img/illustrations/password.svg
var illustrations_password = __webpack_require__(36879);
;// CONCATENATED MODULE: ./src/templates/ForgotPassword/index.tsx






var errorMessages = {
    invalid_token: "Your reset link was invalid - please request a new link."
};
var ForgotPasswordTemplate = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(), errorMessage = ref[0], setErrorMessage = ref[1];
    var _query = router.query, _errorType1 = _query.errorType, errorType = _errorType1 === void 0 ? "" : _errorType1;
    (0,react.useEffect)(function() {
        var _errorType;
        setErrorMessage((_errorType = errorMessages[errorType]) !== null && _errorType !== void 0 ? _errorType : "");
    }, [
        errorType
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(templates_Auth/* default */.Z, {
        illustrationSrc: illustrations_password/* default */.Z,
        illustrationAlt: "A girl walking to a door with a padlock icon on it.",
        children: errorMessage !== undefined && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ForgotPasswordForm_ForgotPasswordForm, {
            initialError: errorMessage
        })
    });
};
/* harmony default export */ var ForgotPassword = (ForgotPasswordTemplate);

;// CONCATENATED MODULE: ./src/pages/forgot-password.page.tsx





var ForgotPasswordPage = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(emotion_react_jsx_runtime_browser_esm.Fragment, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)("title", {
                    children: "Forgot Password - Riiid for Classrooms"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(ForgotPassword, {})
        ]
    });
};
ForgotPasswordPage.layout = Auth/* default */.Z;
/* harmony default export */ var forgot_password_page = (ForgotPasswordPage);


/***/ }),

/***/ 55571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 4 modules
var emotion_styled_browser_esm = __webpack_require__(82227);
;// CONCATENATED MODULE: ./src/templates/Auth/styles.ts

var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("main", {
    target: "e13yas810"
})("display:flex;justify-content:space-between;align-items:center;padding:0 70px;height:100%;");
var IllustrationWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e13yas811"
})("display:flex;justify-content:right;height:610px;");

;// CONCATENATED MODULE: ./src/templates/Auth/index.tsx




var AuthTemplate = function(param) {
    var illustrationSrc = param.illustrationSrc, illustrationAlt = param.illustrationAlt, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsxs)(Wrapper, {
        children: [
            children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(IllustrationWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm.jsx)(next_image["default"], {
                    src: illustrationSrc,
                    alt: illustrationAlt
                })
            })
        ]
    });
};
/* harmony default export */ var Auth = (AuthTemplate);


/***/ }),

/***/ 98404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ isDevelopment; }
/* harmony export */ });
var isDevelopment = "production" !== "production";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [237,774,888,179], function() { return __webpack_exec__(88997); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);